import { Input } from 'components/common/Input';
import { FC, useId, useState } from 'react';
import { useTranslation } from 'react-i18next';

import s from './PaymentCard.module.css';
import { ReactComponent as Arca } from 'images/paymentSystems/arca.svg';
import { ReactComponent as Mastercard } from 'images/paymentSystems/mastercard.svg';
import { ReactComponent as Visa } from 'images/paymentSystems/visa.svg';
import { formatCVV, formatCardNumber, formatExpiry } from 'lib/utils/payment';

const icons = {
  arca: <Arca aria-hidden='true' />,
  mastercard: <Mastercard aria-hidden='true' />,
  visa: <Visa aria-hidden='true' />,
};

type PaymentCardProps = {
  // children?: ReactNode;
};

export const PaymentCard: FC<PaymentCardProps> = () => {
  const { t } = useTranslation();
  const securityNoteId = useId();

  const [cardNumber, setCardNumber] = useState('');
  const [expiry, setExpiry] = useState('');
  const [cvv, setCvv] = useState('');

  const handleCardNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formattedValue = formatCardNumber(e.target.value);
    setCardNumber(formattedValue);
  };

  const handleExpiryChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formattedValue = formatExpiry(e.target.value);
    setExpiry(formattedValue);
  };

  const handleCvvChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formattedValue = formatCVV(e.target.value);
    setCvv(formattedValue);
  };

  return (
    <div className={s['payment-card']}>
      <fieldset
        className={s['payment-card__panel']}
        aria-describedby={securityNoteId}
      >
        <legend className={s['payment-card__legend']}>
          {t('payment.bankCard')}
        </legend>

        <div className={s['payment-card__fields']}>
          <div className={s['payment-card__number']}>
            <Input
              className={s['payment-card__input_number']}
              type='text'
              value={cardNumber}
              onChange={handleCardNumberChange}
              placeholder={t('payment.cardNumber')}
              aria-label={t('payment.cardNumber')}
              autoComplete='cc-number'
            />

            <div
              className={s['payment-card__brands']}
              role='img'
              aria-label='ArCa, Mastercard, Visa'
            >
              {icons.arca}
              {icons.mastercard}
              {icons.visa}
            </div>
          </div>

          <div className={s['payment-card__row']}>
            <Input
              className={s['payment-card__row_input']}
              type='text'
              value={expiry}
              onChange={handleExpiryChange}
              placeholder={t('payment.expiryDate')}
              aria-label={t('payment.expiryDate')}
              autoComplete='cc-exp'
            />

            <Input
              className={`${s['payment-card__row_input']} ${s['payment-card__input_cvv']}`}
              type='text'
              value={cvv}
              onChange={handleCvvChange}
              placeholder='CVV'
              aria-label='CVV'
              autoComplete='cc-csc'
            />
          </div>

          <p className={s['payment-card__note']} id={securityNoteId}>
            {t('payment.securityNote')}
          </p>
        </div>
      </fieldset>
    </div>
  );
};
